import angular from 'angular';

const handler = (/** @type {DragEvent} */ event) => {
	event.preventDefault();
	return false;
};

const disableDropDirective = /* @ngInject */ () => ({
	restrict: 'A',
	/**
	 * @param {any} scope
	 * @param {any} element
	 */
	link(scope, element) {
		element.on('dragenter', (/** @type {DragEvent} */ event) => handler(event));
		element.on('dragover', (/** @type {DragEvent} */ event) => {
			// @ts-ignore
			event.originalEvent.dataTransfer.effectAllowed = 'none';
			// @ts-ignore
			event.originalEvent.dataTransfer.dropEffect = 'none';
			return handler(event);
		});
		element.on('drop', (/** @type {DragEvent} */ event) => handler(event));

		scope.$on('$destroy', () => {
			element.off('dragenter dragover drop');
		});
	},
});

export default angular.module('app')
	.directive('disableDrop', disableDropDirective);
